import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#services", label: "Services", id: "nav-services" },
  { href: "#why", label: "Why Us", id: "nav-why" },
  { href: "#gallery", label: "Gallery", id: "nav-gallery" },
  { href: "#area", label: "Service Area", id: "nav-area" },
  { href: "#contact", label: "Contact", id: "nav-contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-all duration-300 ${
        scrolled
          ? "bg-black/85 backdrop-blur-xl border-[#2A2A2A]"
          : "bg-transparent border-transparent"
      }`}
    >
      <div className="px-6 md:px-12 lg:px-20 h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-2 group">
          <span className="w-3 h-3 bg-[#FFD600] block group-hover:bg-[#00E5FF] transition-colors" />
          <span className="font-display text-2xl md:text-3xl font-bold tracking-tight uppercase">
            Big Bubbles
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.id}
              className="text-sm font-semibold uppercase tracking-widest text-gray-300 hover:text-[#FFD600] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <a
            href="#quote"
            data-testid="nav-quote-btn"
            className="bg-[#FFD600] text-black font-bold uppercase tracking-wider text-sm px-6 py-3 hover:-translate-y-0.5 hover:shadow-[4px_4px_0_0_rgba(255,255,255,0.25)] transition-all inline-block"
          >
            Get a Quote
          </a>
        </div>

        <button
          aria-label="Open menu"
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden text-white p-2 border border-[#2A2A2A]"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#2A2A2A] bg-black/95 backdrop-blur-xl">
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-${l.id}`}
                className="text-sm font-semibold uppercase tracking-widest text-gray-300 hover:text-[#FFD600]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#quote"
              onClick={() => setOpen(false)}
              data-testid="mobile-nav-quote-btn"
              className="bg-[#FFD600] text-black font-bold uppercase tracking-wider text-sm px-6 py-3 inline-block w-fit"
            >
              Get a Quote
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
